import React from "react";

// Teacher/Class 탭(WebTeacherClassConfig.js)과 동일한 화살표 아이콘 (스타일 통일)
const IconFirst = () => (<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="11 17 6 12 11 7" /><polyline points="18 17 13 12 18 7" /></svg>);
const IconPrev = () => (<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="15 18 9 12 15 6" /></svg>);
const IconNext = () => (<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="9 18 15 12 9 6" /></svg>);
const IconLast = () => (<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="13 17 18 12 13 7" /><polyline points="6 17 11 12 6 7" /></svg>);

const createArr = (n) => {
    const iArr = new Array(n);

    for (let i = 0; i < n; i++) {
        iArr[i] = i + 1;
    }

    return iArr;
}

// 한 페이지에 보여줄 개수 선택 옵션 (기본값)
const DEFAULT_LIMIT_OPTIONS = [10, 20, 30, 50, 100];

const WebPagination = ({ total, limit, page, setPage, blockNum, setBlockNum, style, setLimit, limitOptions }) => {

    const pagenationLimit = 10; // 보여줄 페이지네이션 개수

    const totalPage = Math.ceil(total / limit);

    const blockArea = Number(blockNum * pagenationLimit);
    const nArr = createArr(Number(totalPage));
    const pArr = nArr.slice(blockArea, Number(pagenationLimit) + blockArea);

    const firstPage = () => {
        setPage(1);
        setBlockNum(0);
    }

    const lastPage = () => {
        setPage(totalPage);
        setBlockNum(Math.ceil(totalPage / pagenationLimit) - 1);
    }

    const prevPage = () => {
        if (page <= 1) return;

        if (page -1 <= pagenationLimit * blockNum) {
            setBlockNum(prevPage => prevPage - 1);
        }
        setPage(prevPage => prevPage - 1);
    }

    const nextPage = () => {
        if (page >= totalPage) return;

        if (pagenationLimit * Number(blockNum + 1) < Number(page + 1)) {
            setBlockNum(prevPage => prevPage + 1);
        }
        setPage(prevPage => prevPage + 1);
    }

    // 페이지당 표시 개수 변경 시: 개수 변경 + 1페이지로 리셋
    const onChangeLimit = (e) => {
        const newLimit = Number(e.target.value);
        setLimit(newLimit);
        setPage(1);
        setBlockNum(0);
    }

    return (
        // Teacher/Class 탭과 동일한 pagination-container / page-arrow / page-number 스타일 사용
        <nav className="pagination-container" style={style}>
            <button
                className="page-arrow"
                onClick={firstPage}
                disabled={page === 1}
                aria-label="First">
                <IconFirst />
            </button>
            <button
                className="page-arrow"
                onClick={prevPage}
                disabled={page === 1}
                aria-label="Prev">
                <IconPrev />
            </button>
            {
                pArr.map(n => (
                    <button
                        className={`page-number${page === n ? " active" : ""}`}
                        key={"page-" + n}
                        onClick={() => setPage(n)}
                        aria-current={page === n ? "page" : null}>
                        {n}
                    </button>
                ))
            }
            <button
                className="page-arrow"
                onClick={nextPage}
                disabled={page === totalPage}
                aria-label="Next">
                <IconNext />
            </button>
            <button
                className="page-arrow"
                onClick={lastPage}
                disabled={page === totalPage}
                aria-label="Last">
                <IconLast />
            </button>
            {
                // setLimit이 전달된 경우에만 페이지당 개수 선택 노출
                typeof setLimit === "function" &&
                <select
                    className="custom-select small pagination-rows-select"
                    value={limit}
                    onChange={onChangeLimit}>
                    {
                        (limitOptions || DEFAULT_LIMIT_OPTIONS).map(n => (
                            <option key={"limit-" + n} value={n}>{n}개씩</option>
                        ))
                    }
                </select>
            }
        </nav>
    );
}

export default WebPagination;
